import 'script-loader!jquery/dist/jquery.min';
import 'script-loader!what-input/dist/what-input.min';
import 'script-loader!foundation-sites/dist/js/foundation.min';
import 'script-loader!magnific-popup/dist/jquery.magnific-popup.min';
import AOS from 'aos';
import 'aos/dist/aos.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPlay,
  faPause,
  faFileDownload
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import Vue from 'vue';
import App from './App.vue';
import router from './router';

import VueLogger from 'vuejs-logger';

import VueGtag from 'vue-gtag';

const options = {
  isEnabled: true,
  logLevel: process.env.NODE_ENV === 'production' ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
};

Vue.use(VueLogger, options);

Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID }
}, router);

library.add(
  faPlay,
  faFileDownload,
  faPause
);
Vue.component('FontAwesomeIcon', FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.prototype.$quotes = [
  {
    name: 'Zynthia Howse',
    position: 'Senior Claims Attorney',
    quote: 'We advance well supported factual and legal grounds to defend and challenge opposing issues and allegations for the doctors.',
    photo: require('./assets/zynthia-howse.jpg'),
    statistic: {
      number: '88%',
      subtext: 'of practicing physicians will face a malpractice claim in their career',
      graphic: require('./assets/stat1.svg')
    }
  },
  {
    name: 'Jesse Lawler',
    position: 'Business Development Executive',
    quote: 'We only work with the best defense attorneys and provide them with the resources they need to provide the optimal defense.',
    photo: require('./assets/jesse-lawler.jpg'),
    statistic: {
      number: '140K+',
      subtext: 'claims handled',
      graphic: require('./assets/stat2.svg')
    }
  },
  {
    name: 'Michael A. Ricciardelli, CPA',
    position: 'Chief Financial Officer',
    quote: 'A strong legal defense means the willingness to defend good medicine at all costs.',
    photo: require('./assets/michael-ricciardelli.jpg'),
    statistic: {
      number: '30%',
      subtext: 'fewer settlements than the competition',
      graphic: require('./assets/stat3.svg')
    }
  },
  {
    name: 'Savannah Pyles',
    position: 'Assistant Vice President, Underwriting',
    quote: 'It means having an experienced and effective team that is committed to representing our policyholders while having their best interest at heart.',
    photo: require('./assets/savannah-pyles.jpg'),
    statistic: {
      number: '2.2x',
      subtext: 'more defense verdicts than our competitors',
      graphic: require('./assets/stat4.svg')
    }
  }
];

export const vm = new Vue({
  created () {
    AOS.init({
      offset: 220,
      delay: 50,
      duration: 600,
      easing: 'easeOutQuart'
    });
  },
  router: router,
  render: h => h(App)
}).$mount('#app');
